import { createContext, useContext, useMemo, useState } from "react";
import axios from "axios";

import { API_URL } from "./_lib/config";
import { useAdminContext } from "./admin/AdminContext";

const PositionContext = createContext(null);

export const usePositionContext = () => {
  const v = useContext(PositionContext);
  if (!v) {
    throw new Error("usePositionContext must be used inside PositionProvider");
  }
  return v;
};

const safeCall = async (promise) => {
  let errorResponse = null;
  const response = await promise.catch((error) => {
    errorResponse = error?.response ?? null;
  });
  return response ?? errorResponse;
};

export const PositionProvider = ({ children }) => {
  const [position, setPosition] = useState(null);
  const { sysAdmin } = useAdminContext();

  const authConfig = () => ({
    headers: { Authorization: `Bearer ${sysAdmin?.token}` },
  });

  const fetchPosition = async () => {
    const response = await safeCall(axios.get(`${API_URL}/api/v1/position`));
    if (response?.data?.data !== undefined) setPosition(response.data.data);
    return response;
  };

  const createPosition = async (payload) => {
    let error = null;
    const response = await axios
      .post(`${API_URL}/api/v1/position/add`, payload, authConfig())
      .catch((e) => {
        error = e?.response ?? null;
      });
    return { response, error };
  };

  const value = useMemo(
    () => ({ position, fetchPosition, createPosition }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [position, sysAdmin?.token],
  );

  return (
    <PositionContext.Provider value={value}>{children}</PositionContext.Provider>
  );
};
